import { IPreSignRequest, IPreSignResponse, IUploadedFile } from './types'
import { useApi } from '@/composables/use-api'

export const FileApi = {
  preSign(param: IPreSignRequest) {
    const url = `/files/presign`

    return useApi().post<IPreSignResponse>(url, param)
  },

  async uploaded(file_id: string, size: number): Promise<IUploadedFile> {
    const url = `/files/${file_id}/uploaded`
    const reseult = await useApi().post<IUploadedFile>(url, { size: size })

    return reseult.data
  },
}
